import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

// Where Android's back gesture leads from each screen. Anything not listed goes
// Home; Home itself sends the app to the background.
const BACK_TO = {
  'select-mini-games': '/new-game'
};

export function registerBackButton(router) {
  if (!Capacitor.isNativePlatform()) return;

  App.addListener('backButton', () => {
    // AppModal closes the topmost open modal on Escape.
    if (document.querySelector('.modal-backdrop')) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
      return;
    }

    const name = router.currentRoute.value.name;
    if (name === 'home') {
      App.minimizeApp();
      return;
    }
    router.replace(BACK_TO[name] ?? '/');
  });
}
